(function () {
  var intro = document.getElementById('NaaIntro');
  if (!intro) return;

  var key = 'naa_intro_seen';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var force = window.location.search.indexOf('intro=1') !== -1;

  if (!force && (sessionStorage.getItem(key) === '1' || prefersReduced)) {
    intro.remove();
    return;
  }

  document.documentElement.classList.add('naa-intro-lock');
  document.body.classList.add('naa-intro-lock');
  document.body.classList.remove('naa-intro-unlock');
  intro.classList.add('is-active');

  var unlockDelay = 900;
  var unlockDuration = 650;
  var fadeDelay = unlockDelay + unlockDuration - 150;
  var cleanupDelay = fadeDelay + 200;

  window.setTimeout(function () {
    intro.classList.add('is-unlock');
  }, unlockDelay);

  window.setTimeout(function () {
    intro.classList.add('is-fade');
  }, fadeDelay);

  window.setTimeout(function () {
    intro.remove();
    document.documentElement.classList.remove('naa-intro-lock');
    document.body.classList.remove('naa-intro-lock');
    document.body.classList.add('naa-intro-unlock');
    sessionStorage.setItem(key, '1');
  }, cleanupDelay);
})();
